import type { BaseQueryMeta } from '@reduxjs/toolkit/query';
import type { ZodType, z } from 'zod';

/**
 * Validate Factory (useful for rtk-query validation)
 * Will Drop the response if validation fails.
 */
export function validateStrict<T extends ZodType>(
    schema: T
): (response: unknown, meta: unknown, arg: unknown) => z.output<T> {
    return response => schema.parse(response);
}

/**
 * Validate Factory (useful for rtk-query validation)
 * Will Log an error if validation fails, but will not drop the response.
 */
export function validateWarn<T extends ZodType>(
    schema: T // biome-ignore lint/suspicious/noExplicitAny: fine here
): (response: unknown, meta: BaseQueryMeta<any>, arg: unknown) => z.output<T> {
    return (response, meta) => {
        const { error } = schema.safeParse(response);
        if (error) {
            console.error(`[feature/api-validation] ${getDebugUrl(meta)} error:`, error.issues);
        }
        return response as z.output<T>;
    };
}

// biome-ignore lint/suspicious/noExplicitAny: fine here
const getDebugUrl = (meta: BaseQueryMeta<any>) => {
    const url = meta?.request?.url;
    if (!url) {
        return 'unknown';
    }
    return url.replace(new URL(url).origin, '');
};
